import { Component,  OnInit, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LanguageTranslateService } from "src/app/_services/language-translate.service";
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { Router } from "@angular/router";

type Category = { id: string; label: string; count?: number };
type TemplateItem = {
  id: string;
  title: string;
  desc: string;
  categoryId: string;
  icon: string;
  bg: string;
  fg: string;
};

@Component({
    selector: 'app-choose-job-template',
    templateUrl: './choose-job-template.component.html',
    styleUrls: ['./choose-job-template.component.scss'],
    standalone: false
})
export class ChooseJobTemplateComponent extends SubscriptionUtil implements OnInit, OnDestroy {
  translate: any;
  data: any;

  activeCatId = 'all';
  search = '';
  selectedTplId?: string;
  categories: Category[] = [
    { id: 'all', label: 'All templates' },
    { id: 'installation', label: 'Installation' },
    { id: 'inspection', label: 'Site inspection' },
    { id: 'repair', label: 'Repair' },
    { id: 'maintenance', label: 'Maintenance' },
    { id: 'adhoc', label: 'Ad hoc request' },
  ];

  templates: TemplateItem[] = [
    { id: 'ps4',  title: 'PlayStation 4 installation', desc: 'Standard install flow for PS4 consoles.',  categoryId: 'installation', icon: 'pi pi-sliders-h', bg: '#CFE4FF', fg: '#2563EB' },
    { id: 'xbox', title: 'Xbox One installation',       desc: 'Common Xbox One setup tasks.',           categoryId: 'installation', icon: 'pi pi-sliders-h', bg: '#CFE4FF', fg: '#2563EB' },
    { id: 'atari',title: 'Atari installation',          desc: 'Legacy console installation steps.',     categoryId: 'repair',       icon: 'pi pi-wrench',    bg: '#FCDDD1', fg: '#EA580C' },
    { id: 'xbox', title: 'Xbox One installation',       desc: 'Common Xbox One setup tasks.',           categoryId: 'installation', icon: 'pi pi-sliders-h', bg: '#CFE4FF', fg: '#2563EB' },
    { id: 'atari',title: 'Atari installation',          desc: 'Legacy console installation steps.',     categoryId: 'repair',       icon: 'pi pi-wrench',    bg: '#FCDDD1', fg: '#EA580C' },
    { id: 'xbox', title: 'Xbox One installation',       desc: 'Common Xbox One setup tasks.',           categoryId: 'installation', icon: 'pi pi-sliders-h', bg: '#CFE4FF', fg: '#2563EB' },
    { id: 'atari',title: 'Atari installation',          desc: 'Legacy console installation steps.',     categoryId: 'repair',       icon: 'pi pi-wrench',    bg: '#FCDDD1', fg: '#EA580C' },
    // add more…
  ];
  constructor(
    private router: Router,
    public modalRef : BsModalRef,
    private languageTranslateService: LanguageTranslateService,
  ) { 
    super();
  }

  ngOnInit(): void {
    this.getLanguageData();
    this.recalcCounts();
  }
  //Language
  getLanguageData() {
    this.push(this.languageTranslateService.wordSrc$.subscribe(data => { 
      if(Object.keys(data).length != 0){
        this.translate = data
      }
    }))
    console.log("translate",this.translate)
  }

  push(obs:any) {
    super.push(obs);
  }


  trackById = (_: number, x: { id: string }) => x.id;

  setCategory(id: string) {
    this.activeCatId = id;
    // keep selection if still visible; otherwise clear
    const visibleIds = new Set(this.filteredTemplates().map(t => t.id));
    if (this.selectedTplId && !visibleIds.has(this.selectedTplId)) this.selectedTplId = undefined;
  }

  filteredTemplates(): TemplateItem[] {
    const q = this.search.trim().toLowerCase();
    const inCat = (t: TemplateItem) => this.activeCatId === 'all' || t.categoryId === this.activeCatId;
    const matches = (t: TemplateItem) =>
      !q || t.title.toLowerCase().includes(q) || t.desc.toLowerCase().includes(q);
    return this.templates.filter(t => inCat(t) && matches(t));
  }

  categoryLabel = (id: string) => this.categories.find(c => c.id === id)?.label ?? id;

  recalcCounts() {
    const byCat: Record<string, number> = {};
    for (const t of this.templates) byCat[t.categoryId] = (byCat[t.categoryId] ?? 0) + 1;
    this.categories = this.categories.map(c =>
      c.id === 'all' ? { ...c, count: this.templates.length } : { ...c, count: byCat[c.id] ?? 0 }
    );
  }

  createNewTemplate() {
    this.modalRef.hide();
    setTimeout(() => this.router.navigate(['/dashboard/setup/jobOrder/templates/create-v2']), 0);
  }
  nextCreate(){
    this.modalRef.hide();
    setTimeout(() => this.router.navigate(['/dashboard/jobOrders/create-v2']), 0);
  }
}
